
import { Component, Vue } from 'vue-property-decorator'
import { getStorehouseMonitor, setOperation } from '@/api/monitor'
import { getCompanyList } from '@/api/admin'
import { getTotal, getOperation, getMapData } from '@/api/main'
import { IListData } from '@/api/types'
import BaiduMap from '@/components/Map/realTimeMap.vue'

@Component({
  name: 'storehouse',
  components: {
    BaiduMap
  }
})
export default class extends Vue {
  private companyId = ''
  private act:string = '0'
  private mapData = []
  private options = []
  private listQuery = {
    companyId: 0,
    state: 0
  }
  created() {
    this.getList()
    this.getCompany()
  }
  private async getList() {
    const { data } = await getMapData(this.listQuery)
    this.mapData = data
  }
  private async getCompany() {
    const queryData = {
      page: 1,
      pagesize: 100
    }
    const { data } = await getCompanyList(queryData)
    this.options = data.items
  }
  private async seachCondition(st:string, dat:number) {
    if (st === 'com') {
      this.listQuery.companyId = Number(this.companyId)
    }
    if (st === 'st') {
      this.listQuery.state = dat
      this.act = String(dat)
    }
    this.getList()
  }
}
